import { Link } from "react-router-dom";

export default function SimpleGray({ text, href = "", onClick }) {
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="w-full rounded-full border bg-transparent border-zi-border-dark text-zi-text-light dark:text-zi-text-dark flex items-center justify-center py-2.5 outline-none hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
      >
        {text}
      </button>
    );
  }

  return (
    <Link
      to={href}
      className="w-full rounded-full border bg-transparent border-zi-border-dark text-zi-text-light dark:text-zi-text-dark flex items-center justify-center py-2.5 outline-none hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
    >
      {text}
    </Link>
  );
}
